<template>
  <section class="tableWrap">
    <div class="dashWrap">

      <!--      메뉴 목록 -->
      <div class="dashRow">
        <h2 class="tit">메뉴 목록</h2>
        <div class="dashBx">
          <v-tabs>
            <v-tab @click="changeTreeData('HOME')">HOME</v-tab>
            <v-tab @click="changeTreeData('ADMIN')">ADMIN</v-tab>
            <v-tab @click="changeTreeData('MOBILE')">MOBILE</v-tab>
          </v-tabs>
          <tree
              ref="menuTree"
              :data="treeData"
              :options="treeOptions"
              @node:clicked="getMenu"
              @node:dragging:finish="moveMenu"
              v-if="treeVisible">

            <span class="tree-text" slot-scope="{ node }">
<!--              <template v-if="!node.hasChildren()">-->
<!--                <i :class="[node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>-->
<!--                {{ node.text }}-->
<!--              </template>-->

<!--              <template v-else>-->
              <template>
                <i :class="[node.data.menuIcon ? node.data.menuIcon : node.data.activated ? 'fa fa-check-circle' : 'fa fa-ban']"></i>
                {{ node.text }}
              </template>

            </span>

          </tree>

        </div>
        <div class="btnStyleBx">
          <div class="btnCommon justify-center">
            <v-btn class="vIconResize" @click="createMenuForm">
              <v-icon left>mdi mdi-playlist-plus</v-icon> 메뉴 추가
            </v-btn>
          </div>
        </div>
      </div>


      <!--      메뉴 상세-->
      <div class="dashRow">
        <h2 class="tit arrowLink d-flex align-center justify-space-between">
          <span>메뉴 상세</span>
        </h2>
        <div class="dashBx justify-space-around">

          <menu-detail
              :item="menu"
              :is-modify="isModify"
              :parent="parent"
              @callback-saved="savedMenu"
              @callback-cancel="isModify = false"
              @callback-enable-edit="isModify = true"
              @callback-deleted="deletedMenu"/>

        </div>

      </div>

    </div>

  </section>
</template>

<script>
import LiquorTree from 'liquor-tree';
// import {ValidationProvider} from 'vee-validate';

import menuApi from '@/api/MenuApi';
import MenuDetail from "./MenuDetail";
import _ from "lodash";

async function loadTreeData(menuCategory) {
  let temp = await menuApi.list(menuCategory??'HOME');
  temp.forEach(t => genTree(t, 1));

  return temp;
}
const genTree = (item, depth) => {
  item.data = genDataStruct(item);
  // if(depth >= 3) {
  //   item.options = {dropable: false};
  // }
  item.childMenus?.forEach(t => genTree(t, depth+1));
}

function genDataStruct(obj) {
  return {
    menuId : obj.menuId,
    menuName : obj.menuName,
    menuIcon : obj.menuIcon,
    activated : obj.activated
  }
}

export default {
  name: 'Menu',
  components: {
    [LiquorTree.name]: LiquorTree,
    'menu-detail' : MenuDetail
  },
  data: () => ({
        treeData: loadTreeData(),
        treeOptions: {
          parentSelect: true,
          propertyNames: {
            state: 'options',
            text: "menuName",
            children: "childMenus"
          },
          dnd:true
        },
        menu: {},
        parent: {},
        menus: [],
        chart: {},
        isModify: false,
        flagChartEdit: false,
        treeItem: null,
        addedChart: null,
        editedChart: null,
        deletedChartKey: null,
        treeVisible: true
      }
  ),
  methods: {
    async changeTreeData(menuCategory) {
      this.menu = {
        menuCategory,
        menuType: menuCategory === 'ADMIN' ? 'TYPE_LINK' : 'TYPE_BOARD'
      }
      this.parent = {}
      this.treeVisible = false;
      this.treeData = await loadTreeData(menuCategory);
      this.treeVisible = true;
      // const tree = this.$refs.menuTree.tree
      // this.$set(this.$refs.menuTree, 'model', tree.parse(this.treeData));
    },
    async getMenu(node) {

      if(node.states.selected) {

        await node.select(false);
        node.unselect();

        this.treeItem = node;
        this.menu = {}
        this.parent = null;
        this.isModify = true;

      } else {
        this.treeItem = node;
        this.menu = await menuApi.getMenu(node.data.menuId);
        this.parent = _.cloneDeep(this.menu);
        this.isModify = true;
      }
    },
    async createMenuForm() {
      this.menu = {menuCategory:this.menu.menuCategory??'HOME', menuType: this.menu.menuCategory??'HOME' === 'ADMIN' ? 'TYPE_LINK' : 'TYPE_BOARD'};
      this.chart = {};
      this.isModify = false;
    },
    async savedMenu(c) {

      // if((await this.treeData).map(t => t.menuId).includes(c.menuId)) {
      if(this.flatList(this.$refs.menuTree.findAll().tree.model).map(t => t.data.menuId).includes(c.menuId)) {

        this.treeItem.data.menuName = c.menuName;
        this.treeItem.data.activated = c.activated;
        this.treeItem.text = c.menuName;

      } else {

        let item = {
          text: c.menuName,
          data: {
            menuId: c.menuId,
            menuName: c.menuName,
            activated: c.activated,
            text: c.menuName
          },
          state: {selected: false}
        };

        if(c.parentId) {
          this.treeItem.states.expanded = true;
          const parentNode = this.$refs.menuTree.find({
            data: {
              menuId: c.parentId
            }
          })[0];

          parentNode.append(item);
          // this.treeItem = this.$refs.menuTree.append(parentNode, item);
        } else {
          // console.log("--------------")
          // console.log(item);
          this.treeItem = await this.$refs.menuTree.append(item);
          // console.log(this.treeItem);
          // await this.changeTreeData(c.menuCategory);
        }
      }

      this.menu = await menuApi.getMenu(c.menuId);
      this.isModify = true;

    },
    deletedMenu() {
      this.menu = {};
      this.parent = null;
      this.treeItem.remove();
      this.isModify = false;
    },
    async moveMenu(moveNode, destinationNode, pos) {
      let position = new Map();
      position.set('DRAG-ABOVE', 'up');
      position.set('DRAG-BELOW', 'down');
      position.set('DRAG-ON', 'in');
      await menuApi.moveMenu(moveNode.data.menuId, destinationNode.data.menuId, position.get(pos.toUpperCase()));
    },
    flatList(items) {
      if(items && items.length > 0) {
        return items.flatMap(i => {

          if(i.children && i.children.length > 0) {
            return [this.flatList(i.children), i].flatMap(i=>i);
          } else {
            return [i]
          }

        });
      } else
        return [];
    }

  },
  async created() {
    this.menus = await this.treeData;
  }

}
</script>

<style lang="scss" scoped>
@import '../../assets/style/layout/variables';

.dashWrap {
  display: flex;
  flex-flow: row wrap;
}

.dashRow:first-child {
  flex: 0 1 25%;

  &:first-child {
    margin-right: 2%;
  }
}
.dashRow:nth-child(2) {
  flex: 0 1 70%;

}

.tit {
  margin-top: 30px;
  margin-left: 5px;
  margin-bottom: 10px;
  font-size: 18px;
}

.dashBx {
  padding: 20px;
  border: 1px solid #e9e9e9;

  .state {
    padding-top: 37px;
    padding-bottom: 37px;
    cursor: pointer;
    color: #666;

    dt {
      display: flex;
      justify-content: center;
      align-items: baseline;
      margin-bottom: 20px;

      em {
        margin-right: 5px;
        font-size: 50px;
        font-weight: bold;
        color: #333;
      }
    }

    dd {
      font-weight: 500;
    }
  }

  .deposit {
    display: flex;
    padding: 0;

    li {
      display: flex;
      justify-content: space-between;
      flex: 0 0 38%;

      &:nth-child(3) {
        flex: 0 0 24%;
      }

      .depositTit {
        width: 100px;
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-radius: 25px;
        background: #f6f6f6;
        font-size: 13px;
        font-weight: 600;
        color: #555;
        text-align: center;
      }

      .depositNum {
        display: flex;
        padding-top: 50px;
        padding-right: 30px;

        p {
          margin-right: 50px;

          em {
            font-size: 40px;
            font-weight: bold;
          }
        }
      }
    }
  }

}

.h3Title {
  @include h3-title;
}
.tabContent{
  .formInfo {
    @include form-info;
  }
  .formInfoArea{
    &.align-normal{
      align-items: normal !important;
    };
  }
  .list{
    display: flex;
    width: 100% !important;
    img{
      width: 100%;
      height: auto;
    }
  }
  .wh300{
    width: 300px;
    padding: 0;
  }
}
</style>